<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>施工管理</el-breadcrumb-item>
            <el-breadcrumb-item>业绩汇总</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row :gutter="0" style="display: flex; flex-direction: column;justify-items: center; align-items: center;">
            <el-col :span="4">
                <!-- v-if="order_type === 0" -->
                <el-button type="primary" @click="get_jiesuan_add" v-if="false">结算订单</el-button>
            </el-col>
        </el-row>
        <el-row :gutter="0" style="display: flex; flex-direction: column;justify-items: center; align-items: center;background: #686868;height: 100px;">
            <el-col :span="3" style="padding-top: 30px;">
                <span style="font-size: 25px;font-weight: 600; text-align: center;color: #fff;width: 300px;">业绩汇总</span>
            </el-col>
        </el-row>
        <el-row :gutter="0" style=" background: #999;height: 100px;padding-top: 20px;text-align: center;">
            <el-col :span="8"> <span style="opacity: 0.0;">123 </span> </el-col>
            <el-col :span="2">
                <span style="opacity: 0.0;">123 </span>
            </el-col>
            <el-col :span="4">
                <el-date-picker v-model="dateQuery" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="query">
                </el-date-picker>
            </el-col>
            <el-col :span="8"> <span style="opacity: 0.0;">123 </span> </el-col>
        </el-row>
        <div>
            <div class="page">
                <div class="card ">
                    <div class="card_top color01">客户信息汇总</div>
                    <div class="nei01_title">
                        <div class="">
    
                        </div>
                        <!-- <div class="nei01title color06">
                                <span>当日汇总</span>
                            </div> -->
                    </div>
                    <div class="card_body">
                        <div class="nei">
    
                            <div class="nei01">
                                <span class="body01_title">所有客户</span> <span class="body01_body">
                                        {{ data[0].guest_sum }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">线上客户</span> <span class="body01_body">
                                        {{ data[0].guest_sum01 }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">自然客户</span> <span class="body01_body">
                                        {{ data[0].guest_sum02 }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">普通会员</span> <span class="body01_body">
                                        {{ data[0].guest_sum03 }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">高级会员</span> <span class="body01_body">
                                        {{ data[0].guest_sum04 }}</span>
                            </div>
    
                        </div>
                        <!-- <div class="nei">
    
                                <div class="nei01">
                                    <span class="body01_title">所有客户</span> <span class="body01_body">
                                        {{ data[0].guest_sum_today }}</span>
                                </div>
                                <div class="nei01">
                                    <span class="body01_title">网络客户</span> <span class="body01_body">
                                        {{ data[0].guest_sum01_today }}</span>
                                </div>
                                <div class="nei01">
                                    <span class="body01_title">店铺客户</span> <span class="body01_body">
                                        {{ data[0].guest_sum02_today }}</span>
                                </div>
                                <div class="nei01">
                                    <span class="body01_title">普通会员</span> <span class="body01_body">
                                        {{ data[0].guest_sum03_today }}</span>
                                </div>
                                <div class="nei01">
                                    <span class="body01_title">高级会员</span> <span class="body01_body">
                                        {{ data[0].guest_sum04_today }}</span>
                                </div>
    
                            </div> -->
                    </div>
                    <div class="card_buttom"></div>
                </div>
    
                <!-- <div class="card ">
                        <div class="card_top color01">车辆信息汇总</div>
                        <div class="nei01_title">
                        </div>
                        <div class="card_body">
                            <div class="nei">
    
                                <div class="nei01">
                                    <span class="body01_title">服务车辆</span> <span class="body01_body">
                                        {{ data[0].cheliang_sum }}</span>
                                </div>
                                <div class="nei01">
                                    <span class="body01_title">在店车辆</span> <span class="body01_body">
                                        {{ data[0].cheliang_sum01 }}</span>
                                </div>
                                <div class="nei01">
                                    <span class="body01_title">离店车辆</span> <span class="body01_body">
                                        {{ data[0].cheliang_sum02 }}</span>
                                </div>
                            </div>
                           
                        </div>
                        <div class="card_buttom"></div>
                    </div> -->
                <div class="card ">
                    <div class="card_top color01">仓库信息汇总</div>
                    <div class="nei01_title">
    
                        <!-- <div class="nei01title color06">
                                <span>当日汇总</span>
                            </div> -->
                    </div>
                    <div class="card_body">
                        <div class="nei">
    
                            <div class="nei01">
                                <span class="body01_title">入库产品数量</span> <span class="body01_body">
                                        {{ data[0].ruku_count }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">入库产品总成本</span> <span class="body01_body">
                                        {{ data[0].ruku_sum }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">销售出库数量</span> <span class="body01_body">
                                        {{ data[0].chuku_count }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">出库总额</span> <span class="body01_body">
                                        {{ data[0].chuku_sum }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">商城出库数量</span> <span class="body01_body">
                                        {{ data[0].sc_chuku_count }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">商城出库总额</span> <span class="body01_body">
                                        {{ data[0].sc_chuku_sum }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">库存数量</span> <span class="body01_body">
                                        {{ data[0].kucun_count }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">库存数量</span> <span class="body01_body">
                                        {{ data[0].kucun_sum }}</span>
                            </div>
                        </div>
                        <!-- <div class="nei">
                                <div class="nei01">
                                    <span class="body01_title">入库产品数量</span> <span class="body01_body">
                                        {{ data[0].ruku_count_today }}</span>
                                </div>
                                <div class="nei01">
                                    <span class="body01_title">入库产品总额</span> <span class="body01_body">
                                        {{ data[0].ruku_sum_today }}</span>
                                </div>
                                <div class="nei01">
                                    <span class="body01_title">销售出库数量</span> <span class="body01_body">
                                        {{ data[0].chuku_count_today }}</span>
                                </div>
                                <div class="nei01">
                                    <span class="body01_title">销售出库总额</span> <span class="body01_body">
                                        {{ data[0].chuku_sum_today }}</span>
                                </div>
                                <div class="nei01">
                                    <span class="body01_title">商城出库数量</span> <span class="body01_body">
                                        {{ data[0].sc_chuku_count_today }}</span>
                                </div>
                                <div class="nei01">
                                    <span class="body01_title">商城出库总额</span> <span class="body01_body">
                                        {{ data[0].sc_chuku_sum_today }}</span>
                                </div>
                                <div class="nei01">
                                    <span class="body01_title">库存数量</span> <span class="body01_body">
                                        {{ data[0].kucun_count_today }}</span>
                                </div>
                                <div class="nei01">
                                    <span class="body01_title">库存总额</span> <span class="body01_body">
                                        {{ data[0].kucun_sum_today }}</span>
                                </div>
    
                            </div> -->
                    </div>
                    <div class="card_buttom"></div>
                </div>
            </div>
    
            <div class="page">
                <div class="card ">
                    <div class="card_top color01">订单信息汇总</div>
                    <div class="nei01_title">
    
                        <!-- <div class="nei01title color06">
                                <span>当日汇总</span>
                            </div> -->
                    </div>
                    <div class="card_body">
                        <div class="nei">
    
                            <div class="nei01">
                                <span class="body01_title">总数量</span> <span class="body01_body">
                                        {{ data[0].order_count }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">未支付数量</span> <span class="body01_body">
                                        {{ data[0].order01_count }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">未支付总额</span> <span class="body01_body">
                                        {{ data[0].order01_sum }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">已支付数量</span> <span class="body01_body">
                                        {{ data[0].order02_count }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">已支付总额</span> <span class="body01_body">
                                        {{ data[0].order02_sum }}</span>
                            </div>
    
                            <div class="nei01">
                                <span class="body01_title">卡扣总额</span> <span class="body01_body">
                                        {{ data[0].order02_kakou }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">储值套餐总额</span> <span class="body01_body">
                                        {{ data[0].order02_chuzhi }}</span>
                            </div>
    
                        </div>
                    </div>
                    <div class="card_buttom"></div>
                </div>
    
                <div class="card ">
                    <div class="card_top color01">财务信息汇总</div>
                    <div class="nei01_title">
    
                        <!-- <div class="nei01title color06">
                                <span>当日汇总</span>
                            </div> -->
                    </div>
                    <div class="card_body">
                        <div class="nei">
                            <div class="nei01">
                                <span class="body01_title">产品销售总额</span> <span class="body01_body">
                                        {{ data[0].caiwu_order_sum }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">产品成本总额</span> <span class="body01_body">
                                        {{ data[0].caiwu_chengben_sum }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">销售毛利</span> <span class="body01_body">
                                        {{ data[0].caiwu_maoli_sum }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">实收总额</span> <span class="body01_body">
                                        {{ data[0].caiwu_shishou_sum }}</span>
                            </div>
                            <div class="nei01">
                                <span class="body01_title">核销总额</span> <span class="body01_body">
                                        {{ data[0].caiwu_hexiao_sum }}</span>
                            </div>
                        </div>
                        <!-- <div class="nei">
                                <div class="nei01">
                                    <span class="body01_title">产品销售总额</span> <span class="body01_body">
                                        {{ data[0].caiwu_order_sum_today }}</span>
                                </div>
                                <div class="nei01">
                                    <span class="body01_title">产品成本总额</span> <span class="body01_body">
                                        {{ data[0].caiwu_chengben_sum_today }}</span>
                                </div>
                                <div class="nei01">
                                    <span class="body01_title">销售毛利</span> <span class="body01_body">
                                        {{ data[0].caiwu_maoli_sum_today }}</span>
                                </div>
                            </div> -->
                    </div>
                    <div class="card_buttom"></div>
                </div>
    
                <div class="card ">
                    <div class="card_top color01">系统信息汇总</div>
                    <div class="nei01_title">
                    </div>
                    <div class="card_body">
                        <div class="nei">
    
                            <div class="nei01">
                                <span class="body01_title">系统启用时间</span> <span class="body01_body">20240301</span>
                            </div>
    
                            <div class="nei01">
                                <span class="body01_title">系统版本号</span> <span class="body01_body">V2.03</span>
                            </div>
    
                        </div>
                        <div class="nei">
    
                        </div>
                    </div>
                    <div class="card_buttom"></div>
                </div>
    
            </div>
    
        </div>
    </div>
</template>

<script>
import { shallowReactive } from 'vue';
export default {
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一年',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一日',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },

            dateQuery: [],
            queryInfo: {
                C_type: 'get_huizongData',
                date01: '2023/01/01',
                date02: '2039/01/01'
            },
            data: [{
                guest_sum: 0,
                guest_sum01: 0,
                guest_sum02: 0,
                guest_sum03: 0,
                guest_sum04: 0,
                cheliang_sum: 0,
                cheliang_sum01: 0,
                cheliang_sum02: 0,
                ruku_count: 0,
                ruku_sum: 0,
                chuku_count: 0,
                chuku_sum: 0,
                sc_chuku_count: 0,
                sc_chuku_sum: 0,
                kucun_count: 0,
                kucun_sum: 0,
                order_count: 0,
                order01_count: 0,
                order01_sum: 0,
                orde02_count: 0,
                order02_sum: 0,
                caiwu_order_sum: 0,
                caiwu_chengben_sum: 0,
                caiwu_maoli_sum: 0,

                guest_sum_today: 0,
                guest_sum01_today: 0,
                guest_sum02_today: 0,
                guest_sum03_today: 0,
                guest_sum04_today: 0,
                cheliang_sum_today: 0,
                cheliang_sum01_today: 0,
                cheliang_sum02_today: 0,
                ruku_count_today: 0,
                ruku_sum_today: 0,
                chuku_count_today: 0,
                chuku_sum_today: 0,
                sc_chuku_count_today: 0,
                sc_chuku_sum_today: 0,
                kucun_count_today: 0,
                kucun_sum_today: 0,
                order_count_today: 0,
                order01_count_today: 0,
                order01_sum_today: 0,
                orde02_count_today: 0,
                order02_sum_today: 0,
                caiwu_order_sum_today: 0,
                caiwu_chengben_sum_today: 0,
                caiwu_maoli_sum_today: 0
            }],
            datekey: Date.now()
        }
    },
    created() {
        this.getDataList()
        this.$nextTick()
    },
    methods: {
        query() {
            this.queryInfo.date01 = this.dateQuery[0]
            this.queryInfo.date02 = this.dateQuery[1]
            this.getDataList()
        },
        async getDataList() {
            const { data: res } = await this.$http.post('api', this.queryInfo);
            this.data = JSON.parse(res.data)[0].dataList
            // if (!this.data) return;
            console.log(this.data)
        }
    }
}
</script>

<style lang="less" scoped>
.card {
    width: 20%;
    min-width: 500px;
}

.card_top {
    height: 40px;
    background: #333537;
    border-radius: 5px 5px 0 0;
    color: beige;
    font-size: large;
    text-align: center;
    padding-top: 20px;
}

.card_body {
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 350px;
    background: #fff;
}

.card_buttom {
    height: 20px;
    background: #fff;
    border-radius: 0 0 5px 5px;
}

.nei01title {
    width: 50%;
    text-align: center;
}

.nei {
    padding: 10px;
    display: flex;
    flex-direction: column; // justify-content: space-around;
}

.nei01 {
    width: 300px;
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 3px;
    height: 60px;
}

.nei01_title {
    background: #4e8af9;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}

.page {
    widows: 98%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    height: 620px;
    background: #efefef;
}

.color01 {
    background: rgb(68, 68, 68);
}

.color02 {
    background: rgb(12, 74, 74);
}

.color03 {
    background: rgb(10, 13, 41);
}

.color04 {
    background: rgb(8, 27, 4);
}

.color05 {
    background: rgb(237, 251, 193);
}

.color06 {
    background: rgb(204, 237, 197);
}

.body01_title {
    width: 480px;
    text-align: left;
}

.body01_body {
    width: 180px;
    text-align: left;
}
</style>
